import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  useDisclosure,
} from '@nextui-org/react';
import type { Dispatch, SetStateAction } from 'react';
import React from 'react';

import { IconMore } from '@/assets';
import type { AssetData } from '@/contents/user-profile/content/artwork/useUserArwork';

import RemoveAsset from './Remove';
import useSetThumbnail from './useSetThumbnail';

const MoreAction: React.FC<{
  collectionId: number;
  asset: AssetData;
  setIsRemove: Dispatch<SetStateAction<boolean>>;
}> = ({ collectionId, asset, setIsRemove }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { handleSetAsThumbnail } = useSetThumbnail();

  return (
    <div>
      <Dropdown>
        <DropdownTrigger>
          <Button
            onClick={(e) => e.preventDefault()}
            className="mb-3 h-[30px] w-[30px] min-w-0 rounded-[100px] bg-gray-100 p-0"
          >
            <IconMore />
          </Button>
        </DropdownTrigger>
        <DropdownMenu aria-label="Static Actions">
          <DropdownItem
            onClick={() => handleSetAsThumbnail(asset.url, asset.name, collectionId)}
            key="set"
          >
            Set as thumbnail
          </DropdownItem>
          <DropdownItem onClick={onOpen} key="remove">
            Remove from collection
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <RemoveAsset
        collectionId={collectionId}
        assetId={asset.id}
        isOpen={isOpen}
        onClose={onClose}
        setIsRemove={setIsRemove}
      />
    </div>
  );
};

export default MoreAction;
